import React from 'react';
import SpaceRow from 'components/SpaceRow';

const SpaceRowList = ({ spaces = [], selectedPlace, onRowClick }) => {
  const hasHandler = typeof onRowClick === 'function';

  return (
    <div className="flex flex-col gap-4 h-full w-full pb-2">
      {spaces.map((space) => (
        <SpaceRow
          key={space.id}
          space={space}
          active={selectedPlace?.id === space.id}
          onClick={hasHandler ? () => onRowClick(space) : undefined}
          disabled={!hasHandler}
        />
      ))}
    </div>
  );
};

export default SpaceRowList;
